export default __webpack_public_path__ + "static/media/deficits4.a807fee8.svg";